import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import ReportGeneration from './ReportGeneration'
import useGetDailyReport from './useGetDailyReport'
import useGetCustomReport from './useGetCustomReport'
import FinanceReportGeneration from './FinanceReportGeneration'
import useGetFinanceReport from './useGetFinanceReport'

const FinanceReportCard = () => {
    
    // get org id
    const user = JSON.parse(localStorage.getItem('userData'))
    const orgId = user.user.org_id

    const{register, handleSubmit, formState:{errors}, setValue} = useForm({
        defaultValues:{
            startDate:"",
            endDate:"",
            reportType:""
        },
        criteriaMode:"all",
        mode:"onChange"
    })

    // date
    const today = new Date().toISOString().split('T')[0]; // "YYYY-MM-DD"
    console.log(today)
    // report generation page
    const[isOpen, setIsOpen]=useState(false)
    // date [daily report or custom date]
    const[date,setDate] = useState('')
    // state for handling the report data
    const[report,setReport] = useState('');
    // state for handling report params for custom report
    const[reportParams,setReportParams] = useState(null);
    // state for handling report params for daily report
    const[dailyReportParams,setDailyReportParams] = useState(null);
    // state for handling the report type
    const[reportType,setReportType]=useState(null);

    // custom hook for daily report
    const{isPending,isSuccess,isError,data:dailyReportData,refetch}=useGetDailyReport(dailyReportParams);
    // custom hook for getting custom report data
    // const{isGetting,isGot,customReportData,refetch:refetchCusotmReport} = useGetCustomReport(reportParams);
    const {isPending:isGetting,isSuccess:isGot,data:customReportData} = useGetFinanceReport(reportParams)
    // useeffect to set the data
    useEffect(()=>{
        if(dailyReportData){
            setReport(dailyReportData)
        }
        
        if(customReportData){
            setReport(customReportData)
        }
    },[dailyReportData,customReportData])

    // daily report
    const DailyReport=()=>{
        setIsOpen(prev => !prev)
        setDate(today)
        setDailyReportParams({orgId:orgId, date:today})
    }
    const handleCloseModal = () => {
        setIsOpen(false);
        setReport('');
        setDate('');
        setReportParams(null);
        setDailyReportParams(null);
    };

    const onSubmit=(data)=>{
        console.log(data)
        setIsOpen(prev=>!prev)
        setDate(data)
        setReportType(data.reportType)
        setReportParams({orgId:orgId,startDate:data.startDate,endDate:data.endDate,reportType:data.reportType})
    }
    
  return (
    <Card className="shadow-sm rounded-3 border-primary-subtle">
        <CardHeader className="bg-primary-subtle py-2">
            <h6 className="mb-0 text-primary">Download Reports</h6>
        </CardHeader>
        <CardBody className="p-3">
            <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="mb-3">
                <div className="mb-2">
                    <h6 className="fw-bold">Finance Report</h6>
                </div>
                <select
                    className='form-select border-primary-subtle'
                    id='producttype'
                    name='producttype'
                    {...register("reportType",{required:"Report Type is Required"})}
                    defaultValue=""
                >
                    <option value="" disabled>Select Report</option>
                    <option value="credit_report">Credit Report</option>
                    <option value="payment_report">Payment Report</option>
                </select>
            </Row>
            
                <div className="mb-3">
                    <h6 className="fw-bold">Custom Date Range Report</h6>
                </div>
                <Row>
                    <Col>
                    <FormGroup>
                        <Label htmlFor="startDate" className="form-label">
                        Start Date
                        </Label>
                        <input
                        type="date"
                        id="startDate"
                        name="startDate"
                        {...register("startDate",{required:"Start Date is Required"})}
                        className="form-control form-control-sm border-primary-subtle"
                        />
                    </FormGroup>
                    {errors.startDate && <span className="text-danger">{errors.startDate.message}</span>}
                    </Col>
                    <Col>
                    <FormGroup>
                        <Label htmlFor="endDate" className="form-label">
                        End Date
                        </Label>
                        <input
                        type="date"
                        id="endDate"
                        name="endDate"
                        {...register("endDate",{required:"End Date is required"})}
                        className="form-control form-control-sm border-primary-subtle"
                        />
                    </FormGroup>
                    {errors.endDate && <span className="text-danger">{errors.endDate.message}</span>}
                    </Col>
                </Row>
                <div className="text-center">
                    <Button type="submit" color="primary" size="sm">
                        Download Report
                    </Button>
                </div>
            </Form>
        </CardBody>

        <Modal
            isOpen={isOpen}
            size='xl'
            backdrop="static"
            keyboard={false}
            toggle={handleCloseModal}
            fullscreen="xl"
            fade
            scrollable
        >
            <ModalHeader
                close={
                    <button type='button' className='btn-close'
                        onClick={handleCloseModal}
                    />
                }
            >

            </ModalHeader>
            <ModalBody>
                <FinanceReportGeneration
                    dataForReport={report}
                    dateData={date}
                    reportType={reportType}
                />
            </ModalBody>
        </Modal>
    </Card>

  )
}

export default FinanceReportCard